export function isValidHexCode(hexString: string) {
  // make sure the hexString is entered with a leading #, e.g., '#AABBCC80'
  return /^#[0-9A-F]{6}$/i.test(hexString);
}
